import React from 'react';
import PropTypes from 'react-proptypes';
import classnames from 'classnames';
import { DefaultLoader } from 'src/components/loader';

import './button.scss';

/* eslint-disable */
const Button = ({ className, loading, children, ...rest }) => {
    return (
        <div className="button-wrapper">
            <button
                className={classnames(
                    'Button',
                    { loading: loading },
                    className,
                )}
                {...rest}
            >
                {loading ? <DefaultLoader /> : children}
            </button>
        </div>
    );
};

Button.propTypes = {
    type: PropTypes.string,
    loading: PropTypes.bool,
};

Button.defaultProps = {
    type: 'button',
    loading: false,
};

export default Button;
